import { useEffect, useState } from "react";
import { Capacitor, PermissionState } from "@capacitor/core";
import {
  geolocationPermissionStatus,
  notificationPermissionStatus,
  requestGeolocationPermission,
  requestNotificationPermission,
} from "../../../functions/servicePermissions";
import { PermissionOverlay } from "../../molecules/PermissionOverlay/PermissionOverlay";

export const PermissionOverlays = () => {
  const [showGeolocation, setShowGeolocation] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  const prompt = (status: PermissionState) => {
    return (
      status !== "denied" &&
      status !== "granted" &&
      Capacitor.isNativePlatform()
    );
  };

  useEffect(() => {
    const checkPermissions = async () => {
      const geolocationStatus = await geolocationPermissionStatus();
      setShowGeolocation(prompt(geolocationStatus));

      const notificationStatus = await notificationPermissionStatus();
      setShowNotification(prompt(notificationStatus));
    };

    checkPermissions();
  }, []);

  const geolocationGoNext = () => {
    setShowGeolocation(false);
  };
  const notificationGoNext = () => {
    setShowNotification(false);
  };

  return (
    <>
      <PermissionOverlay
        title="Geolocation"
        subtitle="Turning on location services allows us to provide features like:"
        features={[
          {
            icon: "search",
            text: "Search for maps of the area nearest to your location.",
          },
          {
            icon: "map-location",
            text: "It helps with orientation and working with maps when using the mower.",
          },
        ]}
        isOpen={showGeolocation}
        allow={async () => {
          await requestGeolocationPermission();
          geolocationGoNext();
        }}
        goNext={geolocationGoNext}
        allowText="Allow geolocation"
      />
      <PermissionOverlay
        title="Notifications"
        subtitle="Turning on notifications services allows us to provide features like:"
        features={[
          {
            icon: "search",
            text: "Information on the status of mower operation.",
          },
          { icon: "map-location", text: "Advanced remote monitoring" },
        ]}
        isOpen={showNotification}
        allow={async () => {
          await requestNotificationPermission();
          notificationGoNext();
        }}
        goNext={notificationGoNext}
        allowText="Allow notifications"
      />
    </>
  );
};
